/**
 * Description: apphub
 * Author: lixm
 * Date: 2019-06-27
 */

export const apphubApiMap = {
  //添加报警信息
  getwxSendJwt:'/apphub/v1/GetwxSend',
  //报警详细信息录入
  insertCallpoliceJwt:'/apphub/v1/insert-callpolice',
    //报警信息附件信息录入
  insertCallpolicematil:'/apphub/v1/insert-callpolicematil',
    // 创建编号
  getInstance: '/apphub/v1/getInstance',
    //带分页的表单下载数据
  billresourcePage:'/apphub/v1/billresource/page',
    //分页的失物招领数据
  lostpropertyPage:'/apphub/v1/lostproperty/page',
    // 根据失物招领id失误招领详细信息
  lostproperty:'/apphub/v1/lostproperty',
    //获取带分页的寻人启事数据
  lostpersonPage:'/apphub/v1/lostperson/page',
    //根据寻人启事id寻人启事详细信息
  lostperson:'/apphub/v1/lostperson',
    //举报12389提交被举报人信息和举报人信息放入对象中新增到数据库表中
  complaintscenter12389Jwt:'/apphub/v1/complaintscenter12389',
    //举报12389提交新增被举报单位的信息
  complaints12389Jwt: '/apphub/v1/complaints12389',
    //获取12389分页列表分页查询12389投诉概要数据
  app12389PageJwt:'/apphub/v1/12389/page',
    //根据id删除投诉事项
  deleteitem:'/apphub/v1/deleteitem',
    //根据12389的id获取12389详细信息
  App12389:'/apphub/v1/12389',
    //  获取线索举报分页列表
  reportPageJwt:'/apphub/v1/report/page',
    //根据线索举报id获取线索举报详细信息
  reportById:'/apphub/v1/report',
    //根据id删除举报项信息
  deleteCpt:'/apphub/v1/report/delete-cpt',
    // 新增线索举报 根据cptComplaintReportOut存入数据库表
  newReportJwt: '/apphub/v1/report',
  //湖北重新新增线索举报，部门guid从前台传入
  reportJwt: '/apphub/hubeigat/report',
    //新增网上信访根据cptOnlinePetition存入数据库表
  onlinepetitionJwt:'/apphub/v1/onlinepetition',
    // 获取网上信访概要信息分页列表
  onlinepetitionPageJwt:'/apphub/v1/onlinepetition/page',
    //根据网上信访id获取网上信访详细信息
  onlinepetitionById:'/apphub/v1/onlinepetition',
    //新增局长信箱详细信息
  DirectorMailBoxJwt:'/apphub/v1/DirectorMailBox',
    //分页查询邮件概要信息
  mymailboxPageJwt:'/apphub/v1/mymailbox/page',
    //此方法放最后，防止路径冲突 根据id获取我的邮件的详情信息
  myMailboxDetailById: '/apphub/v1/myMailboxDetail',
    // 新增意见建议
  suggestJwt:'/apphub/v1/suggest',
    //app新增意见建议
  appsuggestJwt:'/apphub/v1/appsuggest',
    //保存微报警附件信息
  CallPoliceAttach:'/apphub/v1/CallPoliceAttach',
    //根据附件openId 查询报警信息状态
  CallPoliceStatus:'/apphub/v1/CallPoliceStatus',
  //保存报警信息根据callpolice对象保存至数据库表中
  CallPoliceJwt:'/apphub/v1/CallPolice',
//* 实时路况拉取 分页查询实时路况信息
  traffic:'/apphub/v1/traffic',
  //提交堵路移车
  roadjwt:"/apphub/v1/road",
    //堵路移车根据roadBlock对象创建堵路移车信息
  roadblockJwt: '/apphub/v1/roadblock',
  //湖北新接口-堵路移车提交
  roadtrafficJwt: '/apphub/hubeigat/road/traffic',
    // 分页获取我的微信报警信息
  alarmPageJwt:'/apphub/v1/alarm/page',
    // 分页获取App轻应用数据
  appList:'/apphub/v1/app/list',
    //根据guid修改轻应用分组数据
  appUpload: '/apphub/v1/app/upload',
    //根据guid删除轻应用分组数据
  appDelete:'/apphub/v1/app/delete/',
    //根据v-code版本号查询版本信息数据
  versionVversion:'/apphub/v1/version/',
    //保存app版本信息
  versionAdd:'/apphub/v1/version/add',
    //保存申请公开
  applicationJwt:'/apphub/v1/public/application',
    //依申请列表
  publicGetAppJwt:'/apphub/v1/public/getApp',
    //根据guid查询申请公开信息的附件信息
  getPublicAttById:'/apphub/v1/public/getPublicAtt',
  //获取当前用户容缺材料信息
  getMyTolerance:'/apphub/hubeigat/tolerance',
  //提交容缺材料信息
  commitTolerance:'/apphub/hubeigat/submit/tolerance',
  // 根据用户id搜索乘车备案记录
  getCarRecordById:'/apphub/recordcar/v1/queryRecordCarRecords',
  // 用于检验是否还存在进行中的乘车备案
  checkCarRecordState: '/apphub/recordcar/v1/checkrecord',
  // 1.乘车备案记录出发地和目的地   2.保存乘客信息
  saveCarRecord: '/apphub/recordcar/v1/saveuser',
  // 保存乘车备案车辆信息
  saveCarInfo: '/apphub/recordcar/v1/savecar',
  // 保存乘车备案实时坐标信息
  savelocation:'/apphub/recordcar/v1/location',
  // 备案状态开始
  startCarRecord:'/apphub/recordcar/v1/start',
  // 备案结束信息
  endCarRecord: '/apphub/recordcar/v1/endInformation',
  // 保存截图
  saveFile: '/apphub/recordcar/v1/saveFile',
  //发送短信
  sendLocationMessage: '/apphub/recordcar/v1/sendmessage',
  // 行程目的地变更
  updateDestination: '/apphub/recordcar/v1/updateDestination',
  //获取所有的途径坐标点
  queryAllLocations: '/apphub/recordcar/v1/queryLocations',
  //获取最后的目的地和出发地
  queryLastLocation: '/apphub/recordcar/v1/queryDestination',
}

